var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolDefectAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1.14 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.00048000000000000007,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(-627.096 -464)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(643.191 480)",
    fill: "#f95353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M629.1,485a19.037,19.037,0,0,1,38.045-1h-3.568l4.618,9.236L672.81,484h-3.669a21.035,21.035,0,0,0-42.045,1A21.323,21.323,0,0,0,648,506v-2A19.252,19.252,0,0,1,629.1,485Z",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M661.191,485h-2A11.048,11.048,0,1,1,647,474.051v2.567L654.236,473,647,469.382v2.67A13,13,0,1,0,661.191,485Z",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M663.191,500a6,6,0,1,0,6,6A6.007,6.007,0,0,0,663.191,500Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,663.191,510Z",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(661.191 504)",
    fill: "#303033"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolDefectAnalysis);
export default __webpack_public_path__ + "static/media/tool_defectAnalysis.a3cc9814590f740942a776159507db85.svg";
export { ForwardRef as ReactComponent };